import React from 'react';
import { Link } from 'react-router-dom';
import { Container, makeStyles, Typography } from "@material-ui/core";
import history from '../../services/history';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3, 2),
		height: '100vh',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center'
	},
    link: {
        color: '#64b5f6',
        '&:hover': {
            color: '#53a3df'
        }
    }
}));

const ErrorPage = () => {
    const { root, link } = useStyles();

    const handleGoBackClick = () => {
        history.goBack();
    }

    return (
        <Container className={root}>
            <Typography component="h1" variant="h5" align="center">
                Došlo je do greške (500)
            </Typography>
            <Typography component="h6" variant="h6" align="center">
                <Link className={link} onClick={handleGoBackClick}>
                    Povratak nazad
                </Link>
            </Typography>
        </Container>
    )
}

export default ErrorPage;
